import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { BehaviorSubject, forkJoin, map } from 'rxjs';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class ParametersService {
  private readonly parameters$ = new BehaviorSubject<null | Record<string, Array<{ value: any; label: string }>>>(null);

  static instance: ParametersService;

  constructor(private readonly http: HttpClient, private readonly authService: AuthService) {
    ParametersService.instance = this;
  }

  populateParameters() {
    this.authService
      .waitForHeadersAvailability(() =>
        forkJoin([
          this.http.get<Record<string, Array<{ value: any; label: string }>>>(`${environment.bffParameters}`, {
            headers: this.authService.buildHeaders(),
          }),
          this.getDepartments(),
        ])
      )
      .subscribe({
        next: ([parameters, departmentsResponse]) =>
          this.parameters$.next({
            ...parameters,
            societyType: parameters.societyType.map((societyType) => ({
              ...societyType,
              label: `${societyType.value} - ${societyType.label}`,
            })),
            departments: departmentsResponse.departments,
          }),
      });
  }

  params$(name: string) {
    return this.parameters$.pipe(map((params) => params![name]));
  }

  params(name: string) {
    return this.parameters$.value![name];
  }

  getDepartments() {
    return this.http.get<{
      departments: Array<{
        value: any;
        label: string;
      }>;
    }>(`${environment.bffLocationDepartments}`, {
      headers: this.authService.buildHeaders(),
    });
  }

  getProvinces(departmentCode: string) {
    return this.http.get<
      Array<{
        value: any;
        label: string;
      }>
    >(`${environment.bffLocationDepartmentsProvinces}/${departmentCode}/provinces`, {
      headers: this.authService.buildHeaders(),
    });
  }

  getDistricts(departmentCode: string, provinceCode: string) {
    return this.http.get<
      Array<{
        value: any;
        label: string;
      }>
    >(`${environment.bffLocationDepartmentsProvincesDistricts}/${departmentCode}/provinces/${provinceCode}/districts`, {
      headers: this.authService.buildHeaders(),
    });
  }
}
